import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from 'src/app/commons/abstract-http.service';
import { AdvogadoDTO } from 'src/app/model/dto/advogado.dto';
import { TrocaSenhaRequest } from 'src/app/model/dto/trocaSenhaRequest';
import { ResponseData } from 'src/app/model/response.data';

@Injectable({
  providedIn: 'root'
})
export class AdvogadoService extends AbstractHttpService {

  private readonly END_POINT_BASE = 'advogado';
  private readonly VERIFICAR_EXISTENCIA_ADVOGADO = 'cadastrado';
  private readonly ATUALIZAR_SENHA = 'trocar-senha';
  private readonly RECUPERAR_SENHA = 'recuperar-senha';

  constructor(http: HttpClient) {
    super(http)
  }

  verificarExistenciaAdvogado(cpf: string, email: string): Observable<void> {
    return this.getMethod(`${this.END_POINT_BASE}/${this.VERIFICAR_EXISTENCIA_ADVOGADO}/${cpf}/${email}`)
  }

  criar(advogadoDTO: AdvogadoDTO): Observable<string> {
    return this.postMethod(advogadoDTO, `${this.END_POINT_BASE}`);
  }

  atualizarSenha(novaSenhaForm: TrocaSenhaRequest): Observable<void> {
    return this.putMethod(novaSenhaForm, `${this.END_POINT_BASE}/${this.ATUALIZAR_SENHA}`);
  }

  recuperarSenha(cpf: string): Observable<ResponseData<string>> {
    return this.putMethod<ResponseData<string>>(null, `${this.END_POINT_BASE}/${this.RECUPERAR_SENHA}/${cpf}`);
  }

}
